import React from "react";
import styles from "./ExclusiveSaleBanner.module.scss";

export const ExclusiveSaleBanner: React.FC<{element: HTMLElement}> = (props) => {
  const {element} = props;
  const imgLink = element.dataset.imagelink;
  const imgSrc = element.dataset.imagesrc;
  const imgAlt = element.dataset.imagealt;

  return (
    <React.Fragment>
      <div className={styles.banner}>
        <a href={imgLink}>
          <img src={imgSrc} alt={imgAlt} />
        </a>
      </div>
    </React.Fragment>
  );
};
